import { Injectable } from '@angular/core';
import { FontSet, Theme } from '../entities/common.entities';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private active: Theme;
  private activeFont: FontSet;

  constructor() {
    // This is intentional
  }

  setActiveTheme(theme: Theme): void {
    this.active = theme;
    Object.keys(this.active.properties).forEach(property => {
      document.documentElement.style.setProperty(property, this.active.properties[property]);
    });
  }

  setActiveFont(fontset: FontSet): void {
    if (this.activeFont && this.activeFont?.properties) {
      this.activeFont = fontset;
      Object.keys(this.activeFont?.properties).forEach(property => {
        document.documentElement.style.setProperty(property, this.activeFont.properties[property]);
      });
    }
  }
}
